import React from "react";
import Navbar from "../../components/base/navbar";
import { Marketplace } from "../../components/marketplace/Marketplace";

export const MarketplacePage = () => {
  return <div>
    <Marketplace /></div>;
};
